<div id="live-bulletin">
    <h2>Latest Live Bulletin</h2>
    <div [innerHtml]="liveBulletin">Fetching live bulletin...</div>
</div>
<br /> 
<!-- <div id="eBulletin" class="bulletin" [ngClass]="type" *ngIf="!loadingEditor && latestBulletinIsLive; else no_live_bulletins">
    <div class="bulletinWrapper">
        <div class="bulletinIcon">
            <mat-icon aria-hidden="false" [aria-label]="arialabel">{{ icon }}</mat-icon>
        </div>
        <div class="bulletinMessage" [innerHTML]="message"></div>
        <div class="bulletinClose">
            <button id="closeBtn" mat-icon-button onclick="document.getElementById('eBulletin').style.display='none'" aria-label="Close icon button with an X.">
                <mat-icon aria-hidden="false" aria-label="Close icon button with an X.">close</mat-icon>
            </button>
        </div>
    </div>
</div>
<ng-template #no_live_bulletins>{{ loadingEditor ? 'Fetching bulletin...' : 'No live bulletin found.'}}</ng-template>
-->

<div class="grid-container">
    <span class="spacer"></span>
    <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="addBulletin()" aria-label="Create New Bulletin">
            <mat-icon>add</mat-icon>
            <span>Create New Bulletin</span>
        </button>
    </div>
</div>
<h2>List of Bulletins</h2>
<mat-card class="mat-elevation-z3">
    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
            <!-- Bulletin Column -->
            <ng-container matColumnDef="Details">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;">Bulletin</th>
                <td mat-cell *matCellDef="let bulletin, let i = index;">
                    <!-- <div style="width: 800px;"> -->
                        <div>
                            <strong>Title: </strong>{{ bulletin.title }} 
                        </div>
                        <!-- <div style="padding: 10px 10px 10px 0;">
                            <strong>Message: </strong><br /> 
                            <editor [disabled]="true" [init]="config | cssType: bulletin.type" [(ngModel)]="bulletin.message"></editor>
                        </div> -->
                        <!-- <div style="width: 800px; overflow-wrap: break-word;">
                            <strong>Link: </strong>{{ bulletin.link }} 
                        </div> -->
                    <!-- </div> -->

                </td>
            </ng-container>

            <!-- Message Cell -->
            <ng-container matColumnDef="Message">
                <td mat-cell *matCellDef="let bulletin, let i = index;" colspan="7">
                   
                    <div style="padding: 10px 10px 10px 0;">
                        <strong>Message: </strong><br /> 
                        <ng-container *ngIf="!loadingEditor; else loading" >
                            <editor [disabled]="true" [init]="config | cssType: bulletin.type" [(ngModel)]="bulletin.message" *ngIf="!loadingEditor"></editor>
                        </ng-container>
                        <ng-template #loading>
                            Loading...
                        </ng-template>
                    </div>
                </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 10%;">Type</th>
                <td mat-cell *matCellDef="let bulletin" style="text-align: center;">{{ bulletin.type }}</td>
            </ng-container>

            <!-- Duration Column -->
            <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef style="width: 25%;">Duration</th>
                <td mat-cell *matCellDef="let bulletin">
                    <strong>Start</strong>: {{ bulletin.startDate | date: 'MM/dd/YYYY'}} <br>
                    <strong>End</strong>: {{ bulletin.endDate | date: 'MM/dd/YYYY' }}
                </td>
            </ng-container>

            <!-- Schools Column -->
            <ng-container matColumnDef="bulletinSchoolCount">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;">Schools</th>
                <td mat-cell *matCellDef="let bulletin">
                    {{ bulletin.bulletinSchoolCount }}
                </td>
            </ng-container>

            <!-- Active Column -->
            <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 5%;">Active</th>
                <td mat-cell *matCellDef="let bulletin" style="text-align: center">
                    <mat-checkbox [checked]="bulletin.active" aria-label="Active" disabled></mat-checkbox>
                </td>
            </ng-container>

            <!-- Live Column -->
            <ng-container matColumnDef="bulletinLive">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 5%;">Live</th>
                <td mat-cell *matCellDef="let bulletin" style="text-align: center">
                    <mat-checkbox [checked]="bulletin.bulletinLive" aria-label="Bulletin Live" disabled></mat-checkbox>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 15%;"></th>
                <td mat-cell *matCellDef="let bulletin" style="text-align: center">
                    <button mat-flat-button color="primary" (click)="editBulletin(bulletin)">Edit</button>
                    <button mat-flat-button color="warn" (click)="deleteBulletin(bulletin)">Delete</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: ['Message']"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No bulletins listed.</td>
            </tr>
        </table>
    </div>
</mat-card>